import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { TrialShell, TrialAlert } from '../components/trial/TrialShell';
import { trialApi, saveTrialToken, trialError } from '../components/trial/trialApi';

export default function TrialGoogleCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const { setUser, setToken } = useAuth();
  const [error, setError] = useState('');
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const session = new URLSearchParams(location.hash.slice(1)).get('session_id');
    const state = new URLSearchParams(location.search).get('state');
    if (!session || !state) { setError('Google sign-in was not completed. Please try again.'); return; }
    trialApi.post('/google/exchange', { session_id: session, state }).then(({ data }) => {
      if (data.existing_account) {
        localStorage.setItem('token', data.token); setToken(data.token); setUser(data.user);
        navigate(data.user.workspace_id ? `/workspace/${data.user.workspace_id}` : '/dashboard', { replace: true });
      } else {
        saveTrialToken(data.signup_token);
        navigate(data.checkout_completed ? '/trial-onboarding' : '/free-trial', { replace: true });
      }
    }).catch(err => { setError(trialError(err)); navigate('/free-trial/google', { replace: true }); });
  }, []);
  return <TrialShell focused><h1 className="trial-heading" data-testid="trial-google-title">Continue with Google</h1>{error && <><TrialAlert>{error}</TrialAlert><Link className="trial-primary" to="/free-trial" data-testid="trial-google-retry">Back to signup</Link></>}</TrialShell>;
}